"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTexts = void 0;
const react_1 = require("react");
const mergeTexts_1 = require("./mergeTexts");
/**
 * Merge default translations with overridden translations and return the result memoized by params.
 * If no overridden translations are passed, return default translations.
 * @param translations - default translations
 * @param overriddenTranslations - optional overridden translations
 * @returns merged translations memoized
 */
const useTexts = (translations, overriddenTranslations) => (0, react_1.useMemo)(() => (0, mergeTexts_1.mergeTexts)(translations, overriddenTranslations), [translations, overriddenTranslations]);
exports.useTexts = useTexts;
//# sourceMappingURL=useTexts.js.map